(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  class HeaderLocalizationMerged extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.disclosure__button');
      this.panel = this.querySelector('.disclosure__list-wrapper');
      if (!this.button || !this.panel) return;

      this.button.addEventListener('click', this.toggle.bind(this));
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.onDocumentClick = this.onDocumentClick.bind(this);
      document.addEventListener('click', this.onDocumentClick);

      this.querySelectorAll('.header-localization-merged__link').forEach((link) =>
        link.addEventListener('click', this.onItemClick.bind(this))
      );
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    toggle(event) {
      event.stopPropagation();
      const isOpen = this.button.getAttribute('aria-expanded') === 'true';
      this.button.setAttribute('aria-expanded', (!isOpen).toString());
      this.panel.hidden = isOpen;
    }

    close() {
      this.button.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
    }

    onKeyUp(event) {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') {
        this.close();
        this.button.focus();
      }
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    onItemClick(event) {
      event.preventDefault();
      const link = event.currentTarget;
      const form = link.closest('form');
      if (!form) return;
      const value = link.dataset.value;
      const input = form.querySelector('input[name="country_code"], input[name="locale_code"]');
      if (!input) return;
      input.value = value;

      // Language links can carry a paired market (data-country) so the
      // country/currency switches together with the language: Français
      // pairs with France (EUR), Español with España (EUR), and English
      // offers one entry per market (USD/GBP/CAD/AUD).
      const pairedCountry = link.dataset.country;
      if (input.name === 'locale_code' && pairedCountry) {
        let countryInput = form.querySelector('input[name="country_code"]');
        if (!countryInput) {
          countryInput = document.createElement('input');
          countryInput.type = 'hidden';
          countryInput.name = 'country_code';
          form.appendChild(countryInput);
        }
        countryInput.value = pairedCountry;
      }

      form.submit();
    }
  }

  if (!customElements.get('header-localization-merged')) {
    customElements.define('header-localization-merged', HeaderLocalizationMerged);
  }

  // Mobile: the search row inside the burger menu opens the same search
  // dialog used elsewhere in the header (its icon is just hidden on mobile,
  // see the CSS above), instead of duplicating the whole search markup.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('#MenuDrawerSearchTrigger');
    if (!trigger) return;
    event.preventDefault();

    const drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (drawerDetails) drawerDetails.removeAttribute('open');

    // Target the search instance that is a direct child of <header> — it's
    // the one Dawn keeps active on mobile for this header configuration
    // (the other, nested in .header__icons, is Dawn's desktop-only copy).
    const searchSummary = document.querySelector('.header > .header__search summary');
    if (searchSummary) {
      requestAnimationFrame(() => {
        searchSummary.click();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
